import { render, staticRenderFns } from "./AssetDominantFrequency.vue?vue&type=template&id=f751a848"
import script from "./AssetDominantFrequency.vue?vue&type=script&lang=js"
export * from "./AssetDominantFrequency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports